<div id="admin-menu-body">
    <div class="tab-title">Contacts</div>
    <div *ngIf="initControlsFlag" class="form-section" [formGroup]="contacts">
        <div class="formControlBlock">
            <div class="quickview-label" *ngIf="action === 'View'">
                Primary Contact Email
            </div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ primaryEmail.value }}
            </div>
            <div *ngIf="action !== 'View'">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Primary Contact Email</mat-label>
                    <input
                        matInput
                        formControlName="primaryEmail"
                        type="text"
                        outlined
                    />
                </mat-form-field>
                <validator
                    [control]="primaryEmail"
                    [name]="'Primary Email'"
                ></validator>
            </div>
        </div>
        <div class="formControlBlock">
            <div class="quickview-label" *ngIf="action === 'View'">
                Technical Contact Email
            </div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ technicalEmail.value }}
            </div>
            <div *ngIf="action !== 'View'">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Technical Contact Email</mat-label>
                    <input
                        matInput
                        formControlName="technicalEmail"
                        type="text"
                        outlined
                    />
                </mat-form-field>
                <validator
                    [control]="technicalEmail"
                    [name]="'Technical Email'"
                ></validator>
            </div>
        </div>
    </div>
</div>